export const FetchConsts = {
  token: 'token',
  refreshToken: 'refreshToken',
  rememberMeName: 'rememberMe',
}
